const STATUS_CLASSES = Object.freeze({
    draft: 'bg-gray-100 text-gray-600',
    submitted: 'bg-report-status-pending-100 text-report-status-pending-700',
    declined: 'bg-red-50 text-red-500',
    published: 'bg-light-green-50 text-light-green-600',
});

export const reportStatusClasses = (status) => STATUS_CLASSES[status] ?? STATUS_CLASSES.published;
